import clsx from 'clsx';
import { useScheduleOpen } from '../lib/useScheduleOpen';
import styles from '../Tooltip.module.css';

export function TooltipTrigger({
  triggerRef,
  triggerClassName,
  followCursor,
  openDelayMs = 0,
  setOpen,
  setCursor,
  children,
}) {
  const { schedule, clear, openTimerRef } = useScheduleOpen({ openDelayMs, setOpen });

  return (
    <span
      className={clsx(styles.trigger, triggerClassName)}
      ref={triggerRef}
      onPointerEnter={(e) => {
        schedule(e);
        if (followCursor) {
          setCursor({ x: e.clientX, y: e.clientY });
        }
      }}
      onPointerLeave={() => {
        clear();
        setOpen(false);
      }}
      onPointerMove={(e) => {
        if (followCursor) setCursor({ x: e.clientX, y: e.clientY });
        if (openTimerRef.current == null) schedule(e);
      }}
      onFocus={() => {
        clear();
        setOpen(true);
      }}
      onBlur={() => {
        clear();
        setOpen(false);
      }}
    >
      {children}
    </span>
  );
}
